/* cwclientelements
   copyright 2019 LOGILAB S.A. (Paris, FRANCE), all rights reserved.
   contact http://www.logilab.fr/ -- mailto:contact@logilab.fr
*/

import * as React from 'react';
import {buildIntegerAttributeValidation, getDisplayText} from './commons';
import {
    EntityAttribute,
    EntityAttributeProps,
    ENTITY_ATTRIBUTE_DEFAULT_PROPS,
} from './EntityAttribute';
import {DefaultEntityAttribute} from './DefaultEntityAttribute';

/**
 * The default props for a integer entity attribute
 */
export const INTEGER_ENTITY_ATTRIBUTE_DEFAULT_PROPS = {
    ...ENTITY_ATTRIBUTE_DEFAULT_PROPS,
    validateValue: buildIntegerAttributeValidation(undefined, undefined),
    onFieldInputEnded: (component: EntityAttribute, input: string) => {
        if (
            input.length === 0 &&
            !component.props.isRequired(component.props.attribute)
        ) {
            // the new value is empty and not required
            // => convert to unset value
            return component.props.onFieldEditedValue(component, null);
        }
        try {
            let value = Number.parseInt(input, 10);
            component.props.onFieldEditedValue(component, value);
        } catch (error) {
            // not a number?
            component.props.onFieldEditedValue(component, input);
        }
    },
    renderInput: (component: EntityAttribute) => {
        let text = getDisplayText(component.state.value);
        return (
            <input
                type={'number'}
                disabled={component.props.disabled}
                required={component.props.isRequired(component.props.attribute)}
                value={text}
                onChange={(event) =>
                    component.props.onFieldChange(component, event)
                }
                onBlur={(event) =>
                    component.props.onFieldBlur(component, event)
                }
            />
        );
    },
};

/**
 * Component for rendering an integer entity attribute
 */
export class IntegerEntityAttribute extends React.Component<EntityAttributeProps> {
    public static defaultProps = INTEGER_ENTITY_ATTRIBUTE_DEFAULT_PROPS;

    render() {
        return <DefaultEntityAttribute {...this.props} />;
    }
}
